import React from 'react';
import SocialLinks from '../components/atoms/SocialLinks';
import './PublicFooter.css';

const PublicFooter = () => {
  return (
    <footer className="public-footer">
      <div className="public-footer-inner">
        <div className="public-footer-brand">
          <a href="/" className="public-footer-logo">
            <img src="/shaded_cube_logo.svg" alt="Zibby" />
            <span className="public-footer-logo-text">Zibby</span>
          </a>
          <p className="public-footer-copy">
            BY ZIBBY<br />
            &copy; {new Date().getFullYear()} Zibby Inc.
          </p>
          <SocialLinks className="public-footer-socials" />
        </div>
        <div className="public-footer-col">
          <h4>Platform</h4>
          <ul>
            <li><a href="/solutions">Agent platform</a></li>
            <li><a href="https://docs.zibby.app" target="_blank" rel="noopener noreferrer">Documentation</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/connect">Login</a></li>
          </ul>
        </div>
        <div className="public-footer-col">
          <h4>Recipes</h4>
          <ul>
            <li><a href="https://docs.zibby.app/recipes/test" target="_blank" rel="noopener noreferrer">Browser testing</a></li>
            <li><a href="/solutions">Code analysis</a></li>
            <li><a href="https://docs.zibby.app/recipes" target="_blank" rel="noopener noreferrer">Build your own →</a></li>
          </ul>
        </div>
        <div className="public-footer-col">
          <h4>Company</h4>
          <ul>
            <li><a href="/privacy">Privacy policy</a></li>
            <li><a href="/terms">Terms of service</a></li>
            <li><a href="mailto:support@zibby.dev">Contact</a></li>
            <li><a href="/download">Download Studio</a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
